<script>
import toolbarMixin from "../../extensions/mixins/mixin-toolbar";
import ErrorBoundary from "@/components/core/error-boundary";
import AdManager from "@/extensions/managers/ad-manager";
import PmAnimationsLayout from "./animations-layout";
// import { invokeFlutterService } from '@/utils/flutter/flutter-service';

export default {
    mixins: [toolbarMixin],

    components: {
        ErrorBoundary,
        PmAnimationsLayout,
    },

    data: () => ({
        grid: 1,
        currentView: "all",
    }),

    watch: {
        currentView() {
            this.updateToolbar();
        }
    },

    beforeRouteEnter(to, from, next) {
        if (window.packageName && !['com.denticalc.videos', 'com.denticalc.4in1'].includes(window.packageName)) return(next({name: "home"}));
        AdManager.logRouteView('animations');
        return next();
    },

    beforeRouteLeave(to, from, next) {
        // if (app.$isIOS()) invokeFlutterService("FlutterOrientationService", "lock");
        return next();
    },

    created() {

    },

    mounted() {
        if (window["packageName"] === "com.denticalc.photos") {
            window.app.notifyFlutterMounted();
        }
    },

    toolbar() {
        const items = [];

        if (!window.packageName) {
            items.push({
                key: "back",
                icon: "chevron_left",
                iconClass: "app-back-button-icon",
                callback: () => {
                    this.$router.push("/");
                },
            });

            items.push({
                key: "options",
                icon: "currency_usd",
                text: this.$t("plan_simple.prices"),
                callback: () => {
                    this.$store.state.simplePlan.openSelectedDetails = true;
                    this.$router.push("/");
                },
            });

            items.push({
                key: "videos",
                icon: "movie_open_outline",
                active: true,
                text: this.$t("menu.videos"),
                callback: (btn) => {
                    // this.$router.push("/animations");
                    this.selectedAnimation = 0;
                },
            });

            items.push({
                key: "reset",
                iconStyle: "opacity: .6",
                textStyle: "opacity: .6",
                icon: "reset",
                text: this.$t("core.reset"),
            });
        } else if (window.packageName === "com.denticalc.videos") {

        } else {
            items.push({
                mdi: "play-box-outline",
                text: app.$t('menu.videos'),
                // active: this.$router.currentRoute.name==="animations",
                active: this.currentView === "all",
                callback: () => {
                    this.currentView = "all";
                    // this.$router.push('/animations');
                },
            });
            /*items.push({
                mdi: "format-list-bulleted-square",
                text: "Categories",
                active: this.currentView === "categories",
                callback: () => {
                    this.currentView = "categories";
                    // this.$router.push('/animations/categories');
                },
            });*/
            items.push({
                mdi: "versus",
                text: app.$t('videos.compare'),
                active: this.currentView === "vs",
                callback: () => {
                    this.currentView = "vs";
                },
            });
            items.push({
                mdi: "heart-outline",
                // active: this.$router.currentRoute.name==="animation-favourites",
                active: this.currentView === "favourites",
                text: app.$t('photos.favourites'),
                callback: () => {
                    this.currentView = "favourites";
                    // this.$router.push('/animations/favourites');
                },
            });

            items.push({
                back: true,
                // disabled: true,
                callback: () => {
                    if (this.currentView !== 'all') this.currentView = 'all';
                    else this.$router.push("/");
                },
            });
        }

        return ([items]);
    },
}
</script>
